import { render, staticRenderFns } from "./GrmAvatar.vue?vue&type=template&id=8371eeae&scoped=true&"
import script from "./GrmAvatar.vue?vue&type=script&lang=js&"
export * from "./GrmAvatar.vue?vue&type=script&lang=js&"
import style0 from "./GrmAvatar.vue?vue&type=style&index=0&id=8371eeae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8371eeae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8371eeae')) {
      api.createRecord('8371eeae', component.options)
    } else {
      api.reload('8371eeae', component.options)
    }
    module.hot.accept("./GrmAvatar.vue?vue&type=template&id=8371eeae&scoped=true&", function () {
      api.rerender('8371eeae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/avatar/GrmAvatar.vue"
export default component.exports